import React, { useState } from "react";
import { FaPhoneAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { FaInstagram, FaFacebookF } from "react-icons/fa";
import { BsLinkedin } from "react-icons/bs";
import { Link } from "react-router-dom"; // ✅ Import Link
import "../assets/css/header_style.css";
import logo from "../assets/images/header/logo.png";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);


  const handleLinkClick = () => setMenuOpen(false);

  return (
    <header className="header">
      {/* Top Bar */}
      <div className="header-top">
        <div className="contact-info">
          {/* <span>
            <FaPhoneAlt /> +91 9714731830
          </span> */}
          <a
            href="tel:+919714731830"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Call +91 9714731830"
          >
            <span>
              <FaPhoneAlt />
              +91 9714731830
            </span>
          </a>
          {/* <a
            href="https://mail.google.com/mail/?view=cm&fs=1&to=info@milanbrass.com"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Send email to info@milanbrass.com"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <span>
              <MdEmail
                style={{ verticalAlign: "middle", marginRight: "6px" }}
              />
              info@milanbrass.com
            </span>
          </a> */}
          <a
            href="https://mail.google.com/mail/?view=cm&fs=1&to=info@milanbrass.milanbrass.com"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Send email to Milan Brass"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <span>
              <MdEmail
                style={{ verticalAlign: "middle", marginRight: "6px" }}
              />

              info@milanbrass.com
            </span>
          </a>
        </div>
        <div className="social-icons">
          <Link
            to="https://www.instagram.com/milanbrass_401?igsh=anVrOTVzOWZidG1x"
            target="_blank"
            rel="noreferrer"
          >
            <FaInstagram />
          </Link>
          <Link to="#" target="_blank" rel="noreferrer">
            <FaFacebookF />
          </Link>
          <Link
            to="https://www.linkedin.com/in/milan-brass-319834347?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
            target="_blank"
            rel="noreferrer"
          >
            <BsLinkedin />
          </Link>
        </div>
      </div>

      {/* Main Header */}
      <div className="header-main">
        <Link to="/">
          <div className="logo">
            <img src={logo} alt="Milan Brass" />
            <div className="logo-text">
              <h2>MILAN BRASS</h2>
              <p>BUILT IN BRASS</p>
            </div>
          </div>
        </Link>

        {/* Toggle Button */}
        <div
          className={`menu-toggle ${menuOpen ? "active" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>

        {/* Navbar with toggle */}
        <nav className={`navbar ${menuOpen ? "open" : ""}`}>
          <ul>
            <li>
              <Link to="/" onClick={handleLinkClick}>
                Home
              </Link>
            </li>
            <li>
              <Link to="/about" onClick={handleLinkClick}>
                About Us
              </Link>
            </li>
            <li>
              <Link to="/gallery" onClick={handleLinkClick}>
                Gallery
              </Link>
            </li>
            <li>
              <Link to="/contact" onClick={handleLinkClick}>
                Contact Us
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
}
